import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { LaunchAssessmentBase } from "../launch/LaunchAssessmentBase";

/**
 * Launch an training session.
 */
export const LaunchTraining = () => (<LaunchAssessmentBase defaultAssessmentType={AssessmentType.TrainingModule} />);
